import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import ContactContent from "../components/ContactContent";
import Header from "../components/Header";

import BtWhatsapp from "../components/ButtonWhatsapp3";
import Bg from "../img/contact/bg.webp"

const Contact = () => {
  return (
    <>
      <Header />
      <main>
        <Breadcrumb
          menu=""
          name="Contato"
          bg={Bg}
        />
        <ContactContent />
        <Footer />
      </main>
      <BtWhatsapp />
      <Scrolltop />
    </>
  );
};

export default Contact;
